import { BaseBlock } from '@components/base-block'
import { colors } from '@styles/colors'
import { intervalToDuration, isAfter, isValid } from 'date-fns'
import { dateFormat } from './date-format'

export const intervalTimeFromNow = ({
  start,
  format = 'HH:mm:ss',
}: {
  start: Date
  format?: string
}) => {
  if (!isValid(start)) return

  const now = new Date()
  const times: { [key in string]: number } = intervalToDuration({
    start,
    end: now,
  })

  const { years, days, hours, minutes, months, seconds } = times

  const time = dateFormat(
    new Date(years, months, days, hours, minutes, seconds),
    format
  )

  return isAfter(now, start) ? (
    <BaseBlock as="span" color={colors.gray400}>
      00:00:00
    </BaseBlock>
  ) : (
    <BaseBlock as="span" color={hours < 4 ? colors.red400 : colors.gray700}>
      {time}
    </BaseBlock>
  )
}
